import DescriptionStep from '@/profile-creation-wizard/components/for-completion/ui/5_description/DescriptionStep.vue';
import RecommendationStep from '@/profile-creation-wizard/components/for-completion/ui/6_recommendation/RecommendationStep.vue';
import PrivacyStep from '@/profile-creation-wizard/components/for-completion/ui/7_privacy/PrivacyStep.vue';
import YourEducationStep from '@/profile-creation-wizard/components/for-completion/ui/your-education/YourEducationStep.vue';
import YourExperienceStep from '@/profile-creation-wizard/components/for-completion/ui/your-experience/YourExperienceStep.vue';
import LinkedImportStep from '@/profile-creation-wizard/components/for-completion/ui/linkedin-import/LinkedInImportStep.vue';
import HeadlineStep from '@/profile-creation-wizard/components/for-creation/ui/1_headline/HeadlineStep.vue';
import CategorizationStep from '@/profile-creation-wizard/components/for-creation/ui/2_categorization/CategorizationStep.vue';
import LocalisationDetails from '@/profile-creation-wizard/components/for-creation/ui/4_localisation/LocalisationStep.vue';
import DailyRateStep from '@/profile-creation-wizard/components/for-creation/ui/dailyRate/DailyRateStep.vue';
import IndustryExpertiseStep from '@/profile-creation-wizard/components/for-creation/ui/industrySkills/IndustryExpertiseStep.vue';
import {ProfileCreationStepGroup, ProfileCreationSteps} from '@/profile-creation-wizard/config/steps/ProfileCreationSteps';
import MaltStrategyFunctionalSkillsStep from '@/profile-creation-wizard/components/for-creation/ui/functionalSkills/MaltStrategyFunctionalSkillsStep.vue';

export enum MaltStrategyCreationStepNumber {
    SIGNUP_HEADLINE = 1,
    SIGNUP_CATEGORIZATION = 2,
    SIGNUP_FUNCTIONAL_SKILLS = 3,
    SIGNUP_INDUSTRY_EXPERTISE = 4,
    SIGNUP_DAILY_RATE = 5,
    SIGNUP_LOCALISATION = 6,
    COMPLETION_LINKEDIN = 7,
    COMPLETION_EXPERIENCE = 8,
    COMPLETION_EDUCATION = 9,
    COMPLETION_DESCRIPTION = 10,
    COMPLETION_RECOMMENDATION = 11,
    COMPLETION_PRIVACY = 12,
}

const totalStep = 12;

export enum MaltStrategyCreationStepPercentage {
    SIGNUP_HEADLINE = 5,
    SIGNUP_CATEGORIZATION = 50,
    SIGNUP_FUNCTIONAL_SKILLS = 50,
    SIGNUP_INDUSTRY_EXPERTISE = 50,
    SIGNUP_DAILY_RATE = 50,
    SIGNUP_LOCALISATION = 50,
    COMPLETION_LINKEDIN = 50,
    COMPLETION_EXPERIENCE = 50,
    COMPLETION_EDUCATION = 50,
    COMPLETION_DESCRIPTION = 50,
    COMPLETION_RECOMMENDATION = 50,
    COMPLETION_PRIVACY = 95,
}

export enum MaltStrategyCreationStepName {
    SIGNUP_HEADLINE = 'signup_headline',
    SIGNUP_CATEGORIZATION = 'signup_categorization',
    SIGNUP_FUNCTIONAL_SKILLS = 'signup_functional_skills',
    SIGNUP_INDUSTRY_EXPERTISE = 'signup_industry_expertise',
    SIGNUP_DAILY_RATE = 'signup_daily_rate',
    SIGNUP_LOCALISATION = 'signup_localisation',
    COMPLETION_LINKEDIN = 'completion_linkedin_import',
    COMPLETION_EXPERIENCE = 'completion_experience',
    COMPLETION_EDUCATION = 'completion_education',
    COMPLETION_DESCRIPTION = 'completion_description',
    COMPLETION_RECOMMENDATION = 'completion_recommendation',
    COMPLETION_PRIVACY = 'completion_privacy',
}

export enum MaltStrategyCreationStepRoute {
    SIGNUP_HEADLINE = '/signup/headline',
    SIGNUP_CATEGORIZATION = '/signup/categorization',
    SIGNUP_FUNCTIONAL_SKILLS = '/signup/functional-skills',
    SIGNUP_INDUSTRY_EXPERTISE = '/signup/industry-expertise',
    SIGNUP_DAILY_RATE = '/signup/daily-rate',
    SIGNUP_LOCALISATION = '/signup/localisation',
    COMPLETION_LINKEDIN = '/completion/linkedin-import',
    COMPLETION_EXPERIENCE = '/completion/experience',
    COMPLETION_EDUCATION = '/completion/education',
    COMPLETION_DESCRIPTION = '/completion/description',
    COMPLETION_RECOMMENDATION = '/completion/recommendation',
    COMPLETION_PRIVACY = '/completion/privacy',
}

export const maltStrategyCreationSteps: ProfileCreationSteps = [
    {
        name: MaltStrategyCreationStepName.SIGNUP_HEADLINE,
        route: MaltStrategyCreationStepRoute.SIGNUP_HEADLINE,
        stepNumber: MaltStrategyCreationStepNumber.SIGNUP_HEADLINE,
        stepCount: totalStep,
        stepPercentage: MaltStrategyCreationStepPercentage.SIGNUP_HEADLINE,
        previousStepName: null,
        nextStepName: MaltStrategyCreationStepName.SIGNUP_CATEGORIZATION,
        group: ProfileCreationStepGroup.SIGNUP,
        component: HeadlineStep,
    },
    {
        name: MaltStrategyCreationStepName.SIGNUP_CATEGORIZATION,
        route: MaltStrategyCreationStepRoute.SIGNUP_CATEGORIZATION,
        stepNumber: MaltStrategyCreationStepNumber.SIGNUP_CATEGORIZATION,
        stepCount: totalStep,
        stepPercentage: MaltStrategyCreationStepPercentage.SIGNUP_CATEGORIZATION,
        previousStepName: MaltStrategyCreationStepName.SIGNUP_HEADLINE,
        nextStepName: MaltStrategyCreationStepName.SIGNUP_FUNCTIONAL_SKILLS,
        group: ProfileCreationStepGroup.SIGNUP,
        component: CategorizationStep,
    },
    {
        name: MaltStrategyCreationStepName.SIGNUP_FUNCTIONAL_SKILLS,
        route: MaltStrategyCreationStepRoute.SIGNUP_FUNCTIONAL_SKILLS,
        stepNumber: MaltStrategyCreationStepNumber.SIGNUP_FUNCTIONAL_SKILLS,
        stepCount: totalStep,
        stepPercentage: MaltStrategyCreationStepPercentage.SIGNUP_FUNCTIONAL_SKILLS,
        previousStepName: MaltStrategyCreationStepName.SIGNUP_CATEGORIZATION,
        nextStepName: MaltStrategyCreationStepName.SIGNUP_INDUSTRY_EXPERTISE,
        group: ProfileCreationStepGroup.SIGNUP,
        component: MaltStrategyFunctionalSkillsStep,
    },
    {
        name: MaltStrategyCreationStepName.SIGNUP_INDUSTRY_EXPERTISE,
        route: MaltStrategyCreationStepRoute.SIGNUP_INDUSTRY_EXPERTISE,
        stepNumber: MaltStrategyCreationStepNumber.SIGNUP_INDUSTRY_EXPERTISE,
        stepCount: totalStep,
        stepPercentage: MaltStrategyCreationStepPercentage.SIGNUP_INDUSTRY_EXPERTISE,
        previousStepName: MaltStrategyCreationStepName.SIGNUP_FUNCTIONAL_SKILLS,
        nextStepName: MaltStrategyCreationStepName.SIGNUP_DAILY_RATE,
        group: ProfileCreationStepGroup.SIGNUP,
        component: IndustryExpertiseStep,
    },
    {
        name: MaltStrategyCreationStepName.SIGNUP_DAILY_RATE,
        route: MaltStrategyCreationStepRoute.SIGNUP_DAILY_RATE,
        stepNumber: MaltStrategyCreationStepNumber.SIGNUP_DAILY_RATE,
        stepCount: totalStep,
        stepPercentage: MaltStrategyCreationStepPercentage.SIGNUP_DAILY_RATE,
        previousStepName: MaltStrategyCreationStepName.SIGNUP_INDUSTRY_EXPERTISE,
        nextStepName: MaltStrategyCreationStepName.SIGNUP_LOCALISATION,
        group: ProfileCreationStepGroup.SIGNUP,
        component: DailyRateStep,
    },
    {
        name: MaltStrategyCreationStepName.SIGNUP_LOCALISATION,
        route: MaltStrategyCreationStepRoute.SIGNUP_LOCALISATION,
        stepNumber: MaltStrategyCreationStepNumber.SIGNUP_LOCALISATION,
        stepCount: totalStep,
        stepPercentage: MaltStrategyCreationStepPercentage.SIGNUP_LOCALISATION,
        previousStepName: MaltStrategyCreationStepName.SIGNUP_DAILY_RATE,
        nextStepName: MaltStrategyCreationStepName.COMPLETION_DESCRIPTION, // signup
        group: ProfileCreationStepGroup.SIGNUP,
        component: LocalisationDetails,
    },
    // Completion
    {
        name: MaltStrategyCreationStepName.COMPLETION_LINKEDIN,
        route: MaltStrategyCreationStepRoute.COMPLETION_LINKEDIN,
        stepNumber: MaltStrategyCreationStepNumber.COMPLETION_LINKEDIN,
        stepCount: totalStep,
        stepPercentage: MaltStrategyCreationStepPercentage.COMPLETION_LINKEDIN,
        previousStepName: null, // signup
        nextStepName: MaltStrategyCreationStepName.COMPLETION_EXPERIENCE,
        group: ProfileCreationStepGroup.COMPLETION,
        component: LinkedImportStep,
    },
    {
        name: MaltStrategyCreationStepName.COMPLETION_EXPERIENCE,
        route: MaltStrategyCreationStepRoute.COMPLETION_EXPERIENCE,
        stepNumber: MaltStrategyCreationStepNumber.COMPLETION_EXPERIENCE,
        stepCount: totalStep,
        stepPercentage: MaltStrategyCreationStepPercentage.COMPLETION_EXPERIENCE,
        previousStepName: MaltStrategyCreationStepName.COMPLETION_LINKEDIN,
        nextStepName: MaltStrategyCreationStepName.COMPLETION_EDUCATION,
        group: ProfileCreationStepGroup.COMPLETION,
        component: YourExperienceStep,
    },
    {
        name: MaltStrategyCreationStepName.COMPLETION_EDUCATION,
        route: MaltStrategyCreationStepRoute.COMPLETION_EDUCATION,
        stepNumber: MaltStrategyCreationStepNumber.COMPLETION_EDUCATION,
        stepCount: totalStep,
        stepPercentage: MaltStrategyCreationStepPercentage.COMPLETION_EDUCATION,
        previousStepName: MaltStrategyCreationStepName.COMPLETION_EXPERIENCE,
        nextStepName: MaltStrategyCreationStepName.COMPLETION_DESCRIPTION,
        group: ProfileCreationStepGroup.COMPLETION,
        component: YourEducationStep,
    },
    {
        name: MaltStrategyCreationStepName.COMPLETION_DESCRIPTION,
        route: MaltStrategyCreationStepRoute.COMPLETION_DESCRIPTION,
        stepNumber: MaltStrategyCreationStepNumber.COMPLETION_DESCRIPTION,
        stepCount: totalStep,
        stepPercentage: MaltStrategyCreationStepPercentage.COMPLETION_DESCRIPTION,
        previousStepName: MaltStrategyCreationStepName.COMPLETION_LINKEDIN,
        nextStepName: MaltStrategyCreationStepName.COMPLETION_RECOMMENDATION,
        group: ProfileCreationStepGroup.COMPLETION,
        component: DescriptionStep,
    },
    {
        name: MaltStrategyCreationStepName.COMPLETION_RECOMMENDATION,
        route: MaltStrategyCreationStepRoute.COMPLETION_RECOMMENDATION,
        stepNumber: MaltStrategyCreationStepNumber.COMPLETION_RECOMMENDATION,
        stepCount: totalStep,
        stepPercentage: MaltStrategyCreationStepPercentage.COMPLETION_RECOMMENDATION,
        previousStepName: MaltStrategyCreationStepName.COMPLETION_DESCRIPTION,
        nextStepName: MaltStrategyCreationStepName.COMPLETION_PRIVACY,
        group: ProfileCreationStepGroup.COMPLETION,
        component: RecommendationStep,
    },
    {
        name: MaltStrategyCreationStepName.COMPLETION_PRIVACY,
        route: MaltStrategyCreationStepRoute.COMPLETION_PRIVACY,
        stepNumber: MaltStrategyCreationStepNumber.COMPLETION_PRIVACY,
        stepCount: totalStep,
        stepPercentage: MaltStrategyCreationStepPercentage.COMPLETION_PRIVACY,
        previousStepName: MaltStrategyCreationStepName.COMPLETION_RECOMMENDATION,
        nextStepName: null, // profile page
        group: ProfileCreationStepGroup.COMPLETION,
        component: PrivacyStep,
    },
];
